import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js";
import { REPORT_TYPES } from "../../../constants/app-constant";
const {
  JournalistNOARanking,
  JournalistNOATrend,
  SOV_NOA_TREND,
  JournalistTonalityNOARanking,
  PublicationNOATrend,

  TonalityNAORanking,
  PublicationNOARanking,
  PublicationTonalityNOARanking,
  CityWiseNOARanking,
  CityWiseNOATrend,
  CityWiseTonality,
  StateWiseTonality,
  CityWiseCCMTonality,
  CityWiseMAVTonality,
  CityWiseCCMRanking,
  PLATFORM_TREND,
  PLATFORM_TONALITY,
  PLATFORM_RANK,
} = REPORT_TYPES;

export const AreaChart = function ({
  data,
  chartTitle,
  xAxisLabel,
  yAxisLabel,
  xAxisMinTick,
  xAxisMaxTick,
  xAxisTickStep,
  graphApiResponse,
  beginAtZero,
  onEntityClick,
  reportType,
  entityList,
  dataByReportType,
  editionList,
  isEmbededWidget,
}) {
  const chartContainer = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    setChartData(graphApiResponse);
  }, [graphApiResponse]);

  useEffect(() => {
    redrawChart();
  }, [chartData]);

  const redrawChart = () => {
    if (
      !chartContainer ||
      !chartContainer.current ||
      !Object.keys(chartData).length
    ) {
      return;
    }
    if (chartInstance) {
      chartInstance.data = chartData;
      chartInstance.update();
      return;
    }
    const ctx = chartContainer.current.getContext("2d");
    const lineChart = new Chart(ctx, {
      type: "line",
      data: chartData,
      options: {
        plugins: {
          labels: false,
        },
        spanGaps: false,
        responsive: true,
        title: {
          display: !!chartTitle,
          text: chartTitle,
          margin: 10,
        },
        tooltips: {
          mode: "point",
          intersect: false,
        },
        legend: {
          labels: {
            boxWidth: 12,
          },
          maxHeight: 65,
        },
        exporting: {
          chartOptions: {
            legend: {
              enabled: true,
              verticalAlign: "bottom",
              maxHeight: 500,
              margin: 25,
            },
          },
        },
        elements: {
          line: {
            tension: 0.000001,
          },
        },
        plugins: {
          filler: {
            propagate: false,
          },
        },
        scales: {
          xAxes: [
            {
              display: true,
              ticks: {
                autoSkip: false,
                maxRotation: 30,
              },
              scaleLabel: {
                display: !!xAxisLabel,
                labelString: xAxisLabel,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: !!yAxisLabel,
                labelString: yAxisLabel,
              },
              ticks: (() => {
                const ticks = {};
                if (typeof xAxisMinTick !== "undefined") {
                  ticks.min = xAxisMinTick;
                }
                if (typeof xAxisMaxTick !== "undefined") {
                  ticks.max = xAxisMaxTick;
                }
                if (typeof xAxisTickStep !== "undefined") {
                  ticks.stepSize = xAxisTickStep;
                }
                if (typeof beginAtZero !== "undefined") {
                  ticks.beginAtZero = beginAtZero;
                }
                ticks.userCallback = function (label) {
                  if (Math.floor(label) === label) {
                    return label;
                  }
                };
                return ticks;
              })(),
            },
          ],
        },
      },
    });
    setChartInstance(lineChart);
  };

  const handlePointsClick = (e, { legend, label }) => {
    try {
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOARanking ||
        reportType === JournalistNOATrend ||
        reportType === PublicationNOARanking ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend ||
        reportType === PLATFORM_RANK ||
        reportType === PLATFORM_TREND
      ) {
        clickedEntity = legend;
      }
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOATrend ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend ||
        reportType === PLATFORM_TREND ||
        reportType == REPORT_TYPES.SOV
      ) {
        routeParams.date = label;
      }
      if (reportType === JournalistNOARanking) {
        routeParams.sourceName = label;
      }
      if (reportType === PublicationNOARanking) {
        const clickedPublication = dataByReportType.filter(
          (elm) => elm.publication_name == label
        )[0];
        routeParams.publication = clickedPublication;
      }
      if (reportType == REPORT_TYPES.SOV) {
        routeParams.date = label;
      }
      if (
        reportType === CityWiseNOARanking ||
        reportType === CityWiseCCMRanking
      ) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == legend
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (
        reportType === JournalistTonalityNOARanking ||
        reportType === TonalityNAORanking ||
        reportType === PublicationTonalityNOARanking ||
        reportType === CityWiseTonality ||
        reportType === StateWiseTonality ||
        reportType === CityWiseCCMTonality ||
        reportType === CityWiseMAVTonality ||
        reportType === PLATFORM_TONALITY
      ) {
        const tone = legend;
        routeParams.tonality = tone;
      }
      if (reportType == PLATFORM_RANK) {
        routeParams.channel_type = label;
      }
      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className={isEmbededWidget ? "biggerWidget" : ""}>
      <canvas
        ref={chartContainer}
        onClick={(e) => {
          try {
            var activePoint = chartInstance.getElementAtEvent(e)[0];
            const label =
              graphApiResponse.labels[activePoint && activePoint["_index"]];
            // labels will be fetched from the labels array [_index];
            // name will be fetched from the lengendItems [_dataset index];
            const legend =
              activePoint._chart.legend.legendItems[activePoint._datasetIndex]
                .text;
            handlePointsClick(e, { legend, label });
          } catch (e) {
            console.log(e);
          }
        }}
      ></canvas>
    </div>
  );
};
